<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <div v-if="order" class="section fill">
      <div class="inner delivery_detail">
        <div class="box_title">
          <h2>{{ $t('views.member.ordertracking.9320') }}</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.ordertracking.1834') }}</p> -->
        </div>

        <div class="mypage_detail">
          <div class="box">
            <div class="order_title">
              <dl>
                <dt>{{ $t('views.member.ordertracking.9972') }}</dt>
                <dd>
                  <span>{{ order.orderDtime | timestamp }}</span>
                </dd>
                <dt>{{ $t('views.member.ordertracking.1847') }}</dt>
                <dd>{{ order.orderCd }}</dd>
              </dl>
            </div>
            <ul class="order_book">
              <li v-for="(item, idx) in order.orderGoodsList" :key="idx">
                <div class="cover_wrap">
                  <router-link
                    :to="{ name: 'book_detail', params: { id: item.bookCd } }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </router-link>
                </div>
                <div class="info_wrap">
                  <h3 class="meta_title">
                    {{ item.bookNm }}
                  </h3>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                    <span class="gap">/</span>
                    <!-- <span class="meta_tel">{{ item.phone }}</span> -->
                  </p>
                  <p>
                    <span class="meta_type">{{ item.bookTp }}</span>
                  </p>
                  <p>
                    <span>
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        :number="item.saleAmt"
                      />
                    </span>
                  </p>
                </div>
                <!-- TODO: NEED OTHER STATUS TEXT AND ICONS -->
                <div v-if="idx === 0" class="btn_wrap">
                  <div class="cell">
                    <p class="state_txt">
                      {{ order.delivery.deliveryStateMsg }}
                    </p>
                  </div>
                  <div class="cell">
                    <p class="delivery_txt">
                      {{ $t('views.member.ordertracking.6108') }}
                      <!-- {{ $t('views.member.ordertracking.6108') }} -->
                    </p>
                    <p>
                      <strong v-if="order.delivery.shippingFee">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="order.delivery.shippingFee"
                        />
                      </strong>

                      <strong v-if="!order.delivery.shippingFee">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="0"
                        />
                      </strong>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="box">
            <div class="top_title">
              <p>{{ $t('views.member.ordertracking.2805') }}</p>
            </div>

            <div class="waybill_wrap fl">
              <div class="cell_wrap">
                <div class="cell">
                  <p>
                    <span
                      v-if="order.delivery.deliveryStateMsg === '구매 완료'"
                      class="c_icon ico_buy_complete"
                    ></span>
                    <span
                      v-if="order.delivery.deliveryStateMsg === '배송 준비 중'"
                      class="c_icon ico_delivery_ready"
                    ></span>
                    <span
                      v-if="order.delivery.deliveryStateMsg === '배송 중'"
                      class="c_icon ico_delivery_truck"
                    ></span>

                    <span
                      v-if="order.delivery.deliveryStateMsg === '주문 취소'"
                      class="c_icon ico_order_cancel"
                    ></span>
                    <span
                      v-if="order.delivery.deliveryStateMsg === '반품 요청 중'"
                      class="c_icon ico_return_ask"
                    ></span>
                    <span
                      v-if="order.delivery.deliveryStateMsg === '반품 완료'"
                      class="c_icon ico_return_complete"
                    ></span>
                  </p>
                  <p class="deli_state">
                    <span>{{ order.delivery.deliveryStateMsg }}</span>
                  </p>
                  <p
                    v-if="
                      getAccountOrderDelivery && getAccountOrderDelivery.carrier
                    "
                    class="deli_txt"
                  >
                    <span class="deli_company">{{
                      getAccountOrderDelivery.carrier.name
                    }}</span>
                    <br />
                    <span class="deli_waybill">{{
                      order.delivery.trackingNo
                    }}</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="receiver_wrap fl">
              <dl>
                <dt>{{ $t('views.member.ordertracking.482') }}</dt>
                <dd>
                  <span class="meta_name">{{ order.delivery.deliveryTo }}</span>
                </dd>
                <dt>{{ $t('views.member.ordertracking.6645') }}</dt>
                <dd>
                  <span class="meta_phone">{{ order.delivery.mobileNo }}</span>
                </dd>
                <dt>{{ $t('views.member.ordertracking.7124') }}</dt>
                <dd>
                  <span class="meta_zipcode">({{ order.delivery.zipCd }})</span
                  ><br />
                  <span class="meta_address">{{
                    order.delivery.address1
                  }}</span>
                  <span class="meta_address">{{
                    order.delivery.address2
                  }}</span>
                </dd>
                <dt>{{ $t('views.member.ordertracking.3611') }}</dt>
                <dd>
                  <span class="meta_messagge">{{
                    order.delivery.deliveryMsg
                  }}</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>

        <table v-if="getAccountOrderDelivery" class="table_comm">
          <colgroup>
            <col class="table_col" />
            <col class="table_col" />
            <col class="table_col" />
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('views.member.ordertracking.6174') }}</th>
              <th>{{ $t('views.member.ordertracking.2653') }}</th>
              <th>상태</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(status, idx) in getAccountOrderDelivery.progresses"
              :key="idx"
            >
              <td>{{ status.time | date }}</td>
              <td>{{ status.location.name }}</td>
              <td>{{ status.status.text }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'

import { ACCOUNT_ORDER_DELIVERY_DETAIL_GET } from '@/store/types'

import { mapGetters } from 'vuex'

export default {
  name: 'OrderTracking',

  components: { AccountHead },

  data() {
    return {
      order: null,
      orders: [
        {
          date: '2020.02.04 11:20:00',
          currentLocation: '용인수지우체국',
          // options: 배송중(입고), 배송중(출고), 배달중, 배달완료, 집하, 집하예정
          status: '배달완료'
        },
        {
          date: '2020.02.04 11:20:00',
          currentLocation: '용인수지우체국',
          // options: 배송중(입고), 배송중(출고), 배달중, 배달완료, 집하, 집하예정
          status: '배달중'
        },
        {
          date: '2020.02.04 11:20:00',
          currentLocation: '서울용산우체국	',
          // options: 배송중(입고), 배송중(출고), 배달중, 배달완료, 집하, 집하예정
          status: '배송중(출고)'
        },
        {
          date: '2020.02.04 11:20:00',
          currentLocation: '서울용산우체국	',
          // options: 배송중(입고), 배송중(출고), 배달중, 배달완료, 집하, 집하예정
          status: '집하'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'isAccountOrderDeliveryLoading',
      'getAccountOrderDelivery',
      'getCurrency'
    ])
  },
  async mounted() {
    const { order } = this.$route.params
    if (!order) {
      this.$router.push({ name: 'orders' })
    } else {
      this.order = order
      const { carrier, trackingNo } = order.delivery

      await this.$store.dispatch(ACCOUNT_ORDER_DELIVERY_DETAIL_GET, {
        carrier,
        trackingNo
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
